"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VectorLayerGroup = void 0;
var ZoomToDataBounds_1 = require("../../vector/ZoomToDataBounds");
var ste_simple_events_1 = require("ste-simple-events");
var olExtent = require("ol/extent");
var VectorLayerGroup = /** @class */ (function () {
    function VectorLayerGroup(_layerType, _layerSubType, _displayName, _ref, _url, _layerLegend) {
        if (_layerLegend === void 0) { _layerLegend = null; }
        var _this = this;
        this._layerType = _layerType;
        this._layerSubType = _layerSubType;
        this._displayName = _displayName;
        this._ref = _ref;
        this._url = _url;
        this.zoomToDataBounds = ZoomToDataBounds_1.ZoomToDataBounds.Never;
        this.restrictMapExtentToDataBounds = false;
        this.hasZoomedToBounds = false;
        //event - LayerGroupLoading
        this._onLayerGroupLoading = new ste_simple_events_1.SimpleEventDispatcher();
        //event - LayerGroupLoaded
        this._onLayerGroupLoaded = new ste_simple_events_1.SimpleEventDispatcher();
        this.isVisible = function (store) {
            return store.isLayerVisibile(_this._ref, _this.visibleOnFirstLoad);
        };
        /**
        * Returns false if the layer group is turned on and at least one child layer is enabled, i.e. within zoom limits
        * @param store This is the MapStore
        * @param mapZoom This is the zoom level of the map
        * @returns returns a string version of bar
        */
        this.isDisabled = function (store, mapZoom) {
            if (!store.isLayerVisibile(_this._ref, _this.visibleOnFirstLoad)) {
                //is the layer even turned on?
                return false;
            }
            //are all the child layers within zoom bounds?
            for (var _i = 0, _a = _this.layers; _i < _a.length; _i++) {
                var lyr = _a[_i];
                if (lyr.visible === true) {
                    return false;
                }
            }
            return true;
        };
        this.setLayersVisibility = function (mapZoom, store) {
            for (var _i = 0, _a = _this.layers; _i < _a.length; _i++) {
                var lyr = _a[_i];
                lyr.setVisibility(mapZoom, store);
            }
        };
        this.getBoundsForLoadedLayers = function () {
            var dataBounds = olExtent.createEmpty();
            _this.layers.forEach(function (layer) {
                if (layer.loadedBounds !== null && !olExtent.isEmpty(layer.loadedBounds)) {
                    dataBounds = olExtent.extend(dataBounds, layer.loadedBounds);
                }
            });
            return dataBounds;
        };
        this.reLoadLayers = function () {
            _this.hasZoomedToBounds = false;
            _this.layers.forEach(function (layer) {
                layer.clearSource();
            });
        };
        this.setLayerSources = function (map, vectorLayerSourceFactory) {
            var self = _this;
            for (var _i = 0, _a = self.layers; _i < _a.length; _i++) {
                var vectorLayer = _a[_i];
                var vectorLayerSource = vectorLayerSourceFactory.instance(map, vectorLayer, self.wfsParams, self.featureAdd, self.url, self.urlParams);
                vectorLayer.setSource(vectorLayerSource);
                self.addLayerHandler(vectorLayer);
            }
        };
        this.addLayerHandler = function (vectorLayer) {
            vectorLayer.onLayerLoading.subscribe(_this.onVectorLayerLoading);
            vectorLayer.onLayerLoaded.subscribe(_this.onVectorLayerLoaded);
        };
        this.onVectorLayerLoading = function (args) {
            var self = _this;
            if (self._loadingCount === 0) {
                //reset at start of loading
                self._maxFeatureCountReached = false;
                self._featureCount = 0;
                self._loadedDataBounds = olExtent.createEmpty();
                self._onLayerGroupLoading.dispatch({
                    layerGroup: self
                });
            }
            self._loadingCount += 1;
        };
        this.onVectorLayerLoaded = function (args) {
            var self = _this;
            if (args.maxFeatureCountReached === true) {
                self._maxFeatureCountReached = true;
            }
            if (args.dataBounds) {
                self._loadedDataBounds = olExtent.extend(self._loadedDataBounds, args.dataBounds);
            }
            self._featureCount += args.featureCount;
            self._loadingCount -= 1;
            if (self._loadingCount === 0) {
                //all done
                self._onLayerGroupLoaded.dispatch({
                    layerGroup: self,
                    maxFeatureCountReached: self._maxFeatureCountReached,
                    featureCount: self._featureCount,
                    dataBounds: self._loadedDataBounds
                });
            }
        };
        this._layerLegend = { polygon: true, point: true, line: true };
        if (_layerLegend !== null) {
            this._layerLegend = __assign(__assign({}, this._layerLegend), _layerLegend);
        }
        ;
        this._loadingCount = 0;
        this.displayInLayerSwitcher = true;
        this.displayInLegend = true;
        this.visibleOnFirstLoad = true;
        this.visibleOnLoad = false;
        this.useSelectedStyle = false;
        this.allowZoomToLoadedDataBounds = false;
        this.layers = new Array();
        this.wfsParams = null;
        this.featureAdd = null;
    }
    Object.defineProperty(VectorLayerGroup.prototype, "onLayerGroupLoading", {
        get: function () {
            return this._onLayerGroupLoading.asEvent();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VectorLayerGroup.prototype, "onLayerGroupLoaded", {
        get: function () {
            return this._onLayerGroupLoaded.asEvent();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VectorLayerGroup.prototype, "layerType", {
        get: function () {
            return this._layerType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VectorLayerGroup.prototype, "ref", {
        get: function () {
            return this._ref;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VectorLayerGroup.prototype, "displayName", {
        get: function () {
            return this._displayName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VectorLayerGroup.prototype, "url", {
        get: function () {
            return this._url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VectorLayerGroup.prototype, "layerSubType", {
        get: function () {
            return (this._layerSubType);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(VectorLayerGroup.prototype, "layerLegend", {
        get: function () {
            return this._layerLegend;
        },
        enumerable: false,
        configurable: true
    });
    return VectorLayerGroup;
}());
exports.VectorLayerGroup = VectorLayerGroup;
//# sourceMappingURL=VectorLayerGroup.js.map